// MACHINE DRAFT — clinical and native-speaker review required.
export default {
  "tl": [
    "Mga tanong tungkol sa aking paghahanda",
    "Piliin ang anumang nais mong talakayin sa pangkat na nag-aalaga sa iyo sa ospital.",
    "Piliin ang tanong na ito",
    "I-save ang mga napiling tanong sa Aking Pangangalaga",
    "I-print ang mga napiling tanong",
    "Nasa Aking Pangangalaga na",
    "Na-save sa Aking Pangangalaga sa device na ito ang mga napiling tanong.",
    "Pumili ng isa o higit pang tanong upang i-save o i-print.",
    "Mga tanong na gusto kong itanong",
    "Ito ang mga napili mong tanong tungkol sa paghahanda. Maaari mong i-save ang mga ito sa Aking Pangangalaga o i-print para dalhin sa iyong appointment.",
    "Buksan ang Aking Pangangalaga",
    "Hindi ipinapadala sa ospital ang iyong mga tanong kapag ini-print mo ang mga ito.",
    "Hindi pamalit ang mga tanong na ito sa mga tagubilin ng iyong ospital. Para sa mga gamot, hindi pagkain at pag-inom bago ang operasyon, at mga plano sa pag-uwi mula sa ospital, sundin ang indibidwal na payo ng iyong pangkat na nag-aalaga sa iyo sa ospital.",
    "Kailan ako dapat huminto sa pagkain at pag-inom bago ang operasyon ko?",
    "Alin sa mga karaniwan kong gamot ang dapat kong inumin o baguhin bago ang operasyon ko?",
    "Saan ako dapat pumunta at anong oras ako kailangang dumating?",
    "Saan ako dapat pumunta at kailan ako dapat dumating para ma-admit sa ospital?",
    "Kailangan ko bang mag-ayos ng masasakyan papuntang ospital o magtanong kung kuwalipikado ako sa transportasyon para sa mga pasyente?",
    "Kailangan ko ba ng maghahatid sa akin pauwi o mananatiling kasama ko pagkatapos ng operasyon?",
    "Anong tulong ang maaaring kailanganin ko sa paglabas ng ospital, at kanino ko ito dapat itanong?",
    "Sino ang dapat kong kontakin kung may mga alalahanin ako pagkatapos kong makauwi?"
  ],
  "tr": [
    "Hazırlığımla ilgili sorular",
    "Hastanedeki bakım ekibinizle görüşmek istediğiniz soruları seçin.",
    "Bu soruyu seç",
    "Seçilen soruları Bakımım bölümüne kaydet",
    "Seçilen soruları yazdır",
    "Zaten Bakımım bölümünde kayıtlı",
    "Seçilen sorular bu cihazdaki Bakımım bölümüne kaydedildi.",
    "Kaydetmek veya yazdırmak için bir ya da daha fazla soru seçin.",
    "Sormak istediğim sorular",
    "Bunlar hazırlığınızla ilgili seçtiğiniz sorulardır. Randevunuza götürmek için Bakımım bölümüne kaydedebilir veya yazdırabilirsiniz.",
    "Bakımım bölümünü aç",
    "Soruları yazdırmanız onları hastaneye göndermez.",
    "Bu sorular hastanenizin talimatlarının yerine geçmez. İlaçlar, ameliyat öncesi aç ve susuz kalma ve taburculuk düzenlemeleri konusunda hastanedeki bakım ekibinizin size özel verdiği talimatlara uyun.",
    "Ameliyatımdan önce ne zaman yemek yemeyi ve su dâhil sıvı içmeyi bırakmalıyım?",
    "Ameliyatımdan önce düzenli kullandığım ilaçlardan hangilerini almalı veya değiştirmeliyim?",
    "Nereye gitmem gerekiyor ve saat kaçta gelmeliyim?",
    "Hastaneye yatışım için nereye başvurmalı ve ne zaman gelmeliyim?",
    "Hastaneye ulaşımımı kendim mi ayarlamalıyım, yoksa hasta taşıma hizmetinden yararlanıp yararlanamayacağımı mı sormalıyım?",
    "Ameliyattan sonra beni eve götürecek veya yanımda kalacak birine ihtiyacım olacak mı?",
    "Hastaneden taburcu olurken ne tür yardıma ihtiyacım olabilir ve bunu kiminle görüşmeliyim?",
    "Eve döndükten sonra endişelerim olursa kiminle iletişime geçmeliyim?"
  ],
  "ur": [
    "میری تیاری کے بارے میں سوالات",
    "اپنے ہسپتال کی نگہداشت کرنے والی ٹیم سے جن باتوں پر گفتگو کرنا چاہتے ہیں، وہ منتخب کریں۔",
    "یہ سوال منتخب کریں",
    "منتخب سوالات کو ’میری نگہداشت‘ میں محفوظ کریں",
    "منتخب سوالات پرنٹ کریں",
    "پہلے ہی ’میری نگہداشت‘ میں محفوظ ہے",
    "منتخب سوالات اس ڈیوائس پر ’میری نگہداشت‘ میں محفوظ کر دیے گئے ہیں۔",
    "محفوظ کرنے یا پرنٹ کرنے کے لیے ایک یا زیادہ سوالات منتخب کریں۔",
    "وہ سوالات جو میں پوچھنا چاہتا یا چاہتی ہوں",
    "یہ آپ کی تیاری کے بارے میں منتخب کیے گئے سوالات ہیں۔ آپ انہیں ’میری نگہداشت‘ میں محفوظ کر سکتے ہیں یا اپنی ملاقات پر لے جانے کے لیے پرنٹ کر سکتے ہیں۔",
    "’میری نگہداشت‘ کھولیں",
    "سوالات پرنٹ کرنے سے وہ ہسپتال کو نہیں بھیجے جاتے۔",
    "یہ سوالات آپ کے ہسپتال کی ہدایات کا متبادل نہیں ہیں۔ دواؤں، آپریشن سے پہلے کھانا پینا بند رکھنے اور ہسپتال سے چھٹی کے انتظامات کے بارے میں اپنے ہسپتال کی نگہداشت کرنے والی ٹیم کی انفرادی ہدایات پر عمل کریں۔",
    "اپنے آپریشن سے پہلے مجھے کب سے کھانا اور پینا بند کرنا چاہیے؟",
    "آپریشن سے پہلے اپنی معمول کی کون سی دوائیں مجھے لینی چاہییں یا تبدیل کرنی چاہییں؟",
    "مجھے کہاں جانا ہے اور کتنے بجے پہنچنا ہے؟",
    "ہسپتال میں داخلے کے لیے مجھے کہاں جانا ہے اور کب پہنچنا ہے؟",
    "کیا مجھے ہسپتال جانے کے لیے سواری کا انتظام کرنا ہوگا یا یہ پوچھنا چاہیے کہ کیا میں مریضوں کی ٹرانسپورٹ سروس کا اہل ہوں؟",
    "کیا آپریشن کے بعد مجھے گھر لے جانے یا میرے ساتھ رہنے کے لیے کسی کی ضرورت ہوگی؟",
    "ہسپتال سے چھٹی کے وقت مجھے کس مدد کی ضرورت پڑ سکتی ہے اور اس بارے میں مجھے کس سے بات کرنی چاہیے؟",
    "گھر واپس جانے کے بعد اگر مجھے کوئی تشویش ہو تو کس سے رابطہ کرنا چاہیے؟"
  ],
  "zh": [
    "关于术前准备，我想问的问题",
    "请选择您希望与医院护理团队讨论的问题。",
    "选择此问题",
    "将选中的问题保存到“我的护理”",
    "打印选中的问题",
    "已保存到“我的护理”",
    "选中的问题已保存在此设备的“我的护理”中。",
    "请选择一个或多个问题，以便保存或打印。",
    "我想询问的问题",
    "这些是您选出的准备事项相关问题。您可以将它们保存到“我的护理”，或打印出来带到就诊时使用。",
    "打开“我的护理”",
    "打印问题不会将这些内容发送给医院。",
    "这些问题不能替代医院的指示。关于药物、术前禁食禁饮以及出院安排，请遵循医院护理团队针对您个人情况提供的建议。",
    "手术前我应该从什么时候开始停止进食和饮水？",
    "手术前，我平时服用的哪些药物需要继续服用或调整？",
    "我应该去哪里，几点到达？",
    "办理住院时，我应该去哪里，什么时候到达？",
    "我需要自己安排前往医院的交通，还是应该询问自己是否符合患者接送服务的条件？",
    "手术后，我是否需要有人送我回家或陪伴我？",
    "出院时我可能需要哪些帮助，应该和谁讨论？",
    "回家后如果有任何担忧，我应该联系谁？"
  ]
};
